import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContractPharmacyDetails } from '@module-claims/models/pharmacy.interface';
import { ClaimsService } from '@module-claims/services/claims.service';
import { IAsyncData } from '@module-claims/store/claims.state';
import {
  ContractPharmacyModalClose,
  ContractPharmacyModalSave
} from '@module-claims/store/pharmacy.actions';

@Component({
  selector: 'app-contract-pharmacy-modal',
  templateUrl: './contract-pharmacy-modal.component.html',
  styleUrls: ['./contract-pharmacy-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ContractPharmacyModalComponent implements OnInit, OnDestroy {
  @Input() npi!: string;

  readonly destroy$ = new Subject();

  contractPharmacyDetails$: Observable<IAsyncData<ContractPharmacyDetails>>;
  contractPharmacyDetails?: ContractPharmacyDetails;
  form!: UntypedFormGroup;
  dateTimeFormat = 'M/d/yyyy h:mm a';
  lastSearchDate?: Date;
  searchSubmitted = false;

  constructor(
    private _claimsService: ClaimsService,
    private _fb: UntypedFormBuilder,
    private _store: Store,
    private _cdr: ChangeDetectorRef
  ) {
    this.contractPharmacyDetails$ =
      this._claimsService.contractPharmacyDetails$;
  }

  ngOnInit(): void {
    this._claimsService.clearContractPharmacyDetails();
    this.initForm();

    this.contractPharmacyDetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ data }) => {
        this.contractPharmacyDetails = data;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    this.close();
  }

  close(): void {
    this._store.dispatch(new ContractPharmacyModalClose());
  }

  save(): void {
    if (!this.contractPharmacyDetails) {
      return;
    }

    this._store.dispatch(
      new ContractPharmacyModalSave({
        npi: this.npi,
        hrsaPharmacyId: this.contractPharmacyDetails.hrsa_pharmacy_id
      })
    );
  }

  getContractPharmacyDetails(): void {
    const hrsaPharmacyId = this.form.get('hrsaPharmacyId')?.value;
    if (hrsaPharmacyId) {
      this.searchSubmitted = false;
      this._claimsService
        .getContractPharmacyDetails(hrsaPharmacyId)
        .subscribe(() => {
          this.searchSubmitted = true;
          this.lastSearchDate = new Date();
          this._cdr.detectChanges();
        });
    }
  }

  private initForm(): void {
    this.form = this._fb.group({
      hrsaPharmacyId: [null]
    });
  }
}
